module.exports = __webpack_public_path__ + "img/Artboard 2.70f8adc9.png";